/*
 * @@Description: 筛选
 * @@Author: MuYang
 * @Date: 2021-09-17 17:44:49
 * @LastEditTime: 2021-11-16 16:30:30
 */
import { PREFIX } from '../config'
export default {
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: [String, Number, Function],
      default: ''
    },
    colIndex: {
      type: Number
    }
  },
  data () {
    return {
      value: '',
      visible: false
    }
  },
  computed: {
    disabled () {
      if (this.column.filterMultiple) {
        return !this.value.length
      }
      return !this.value
    },
    multiple () {
      return this.column?.filterMultiple
    },
    filterMethod () {
      return this.column?.filterMethod
    }
  },
  watch: {
    multiple: {
      handler () {
        this.reset()
      },
      immediate: true
    }
  },
  methods: {
    reset () {
      this.value = this.multiple ? [] : ''
    },
    // 对外设置默认值
    emitFilter () {
      this.filterMethod &&
        Promise.resolve(this.filterMethod(this.value)).then(_ => {
          this.visible = false
        })
    },
    renderIcon () {
      return (
        <span
          slot='reference'
          class='iconfont batset-icon sy-dropdown-trigger'
          on-click={() => (this.visible = true)}
        >
          &#xe701;
        </span>
      )
    },
    renderHeader ({ filters, filterMultiple }) {
      return (
        <el-popover
          placement='bottom'
          width='200'
          trigger='click'
          v-model={this.visible}
          // on-hide={this.reset}
        >
          {this.renderIcon()}
          {this.renderContent(filters, filterMultiple)}
        </el-popover>
      )
    },
    // 单选
    renderRadio (filters) {
      let filter
      let radioItems = []
      for (let i = 0; i < filters.length; i++) {
        filter = filters[i]
        radioItems.push(
          <el-radio label={filter.value} disabled={filter.disabled}>
            {filter.text}
          </el-radio>
        )
      }
      return <el-radio-group v-model={this.value}>{radioItems}</el-radio-group>
    },
    // 多选
    renderMultiple (filters = []) {
      console.log(filters)
      let filter
      let multipleBox = []
      for (let i = 0; i < filters.length; i++) {
        filter = filters[i]
        multipleBox.push(
          <el-checkbox label={filter} disabled={filter.disabled}>
            {filter.text}
          </el-checkbox>
        )
      }
      return (
        <el-checkbox-group v-model={this.value}>
          {multipleBox}
        </el-checkbox-group>
      )
    },
    renderContent (filters, filterMultiple) {
      const { disabled, reset, emitFilter } = this
      return (
        <div class={`${PREFIX}-filter-content`}>
          <div class={`${PREFIX}-filter-content-header`}>筛选条件</div>
          <div class={`${PREFIX}-filter-content-main`}>
            {filterMultiple
              ? this.renderMultiple(filters)
              : this.renderRadio(filters)}
            <div class={`${PREFIX}-filter-content-footer`}>
              <el-button size='mini' disabled={disabled} on-click={reset}>
                清除已选
              </el-button>
              <el-button size='mini' disabled={disabled} on-click={emitFilter}>
                确认
              </el-button>
            </div>
          </div>
        </div>
      )
    }
  },
  render () {
    const { column, title, colIndex } = this
    return (
      <div class='sy-virtual-table-dropdown'>
        <div class='sy-virtual-table-dropdown-text'>
          {typeof title === 'function' ? title({ column, colIndex }) : title}
        </div>
        {this.renderHeader(column)}
      </div>
    )
  }
}
